/**
 * Admin Feedback Management Tour
 *
 * A 3-step tour introducing the Feedback Management page to admins.
 * Only shown to users with rp_admin or rp_support global roles.
 */

import type { TourDefinition } from '@/types/tour.types'
import feedbackOverview from './assets/feedback-overview.png'

export const adminFeedbackTour: TourDefinition = {
  tourKey: 'admin-feedback',
  requiredRoles: ['rp_admin', 'rp_support'],
  steps: [
    {
      // Step 1: No target - centered welcome
      target: () => null,
      title: 'Welcome to Feedback Management',
      description:
        'On this page, you can view and manage all of the customer feedback in one place. Easy!',
      cover: <img src={feedbackOverview} alt="Feedback Management overview" style={{ width: '100%', borderRadius: 8 }} />,
    },
    {
      // Step 2: Target the filter pane
      target: () => document.querySelector('[data-tour="feedback-filters"]') as HTMLElement | null,
      title: 'Granular Filters',
      description:
        'In this section you can easily filter customer feedback by many different options. Some fields are drop-downs and some update the list as you are typing. Fun!',
      placement: 'bottom',
    },
    {
      // Step 3: Target the first row's expand button
      target: () => document.querySelector('[data-tour="feedback-expand-row"]') as HTMLElement | null,
      title: 'Exciting details!',
      description:
        'By opening a specific Feedback item, you can see all of the exciting details, including the ability to leave your own comments, change priority or status, and even categorize the feedback item. Awesome-sauce!',
      placement: 'right',
    },
  ],
}
